import React from 'react';
import { List } from 'antd';
import {
  LuBriefcase,
  LuCaptions,
  LuHeart,
  LuMapPinHouse,
  LuSmartphone,
  LuWallet,
} from 'react-icons/lu';
import _ from 'lodash';
import MeetingHistory from 'modules/meeting-history';
import ButtonUpdate from 'modules/dashboard/form/ButtonUpdate';
import ConfirmLearn from 'modules/dashboard/search/ConfirmLearn';
import DeleteCandidateButton from 'modules/dashboard/search/DeleteCandidateButton';

const Detail = ({ record, onFetchMeetingSuccess, refetch }) => {
  const data = [
    {
      icon: <LuSmartphone />,
      text: record?.phone,
      title: 'Số điện thoại',
    },
    {
      icon: <LuBriefcase />,
      text: record?.job,
      title: 'Nghề nghiệp',
    },
    {
      icon: <LuWallet />,
      text: record?.monthly_income
        ? `${_.toNumber(record?.monthly_income).toLocaleString()}VNĐ/tháng`
        : null,
      title: 'Thu nhập hàng tháng',
    },
    {
      icon: <LuHeart />,
      text: record?.marital_status,
      title: 'Tình trạng hôn nhân',
    },
    {
      icon: <LuMapPinHouse />,
      text: record?.address,
      title: 'Địa chỉ',
    },
    {
      icon: <LuCaptions />,
      text: record?.confirm_sale_citizen_id,
      title: 'CCCD/CMND',
      renderText: (item) => (
        <span className="flex items-center gap-1">
          {item.text}{' '}
          <ConfirmLearn record={record} formUpdate onSuccess={refetch} />
        </span>
      ),
    },
  ].filter((item) => !!item.text);

  return (
    <div>
      <div className="grid grid-cols-12 gap-4">
        <div className="md:col-span-3 col-span-12">
          <List
            dataSource={data}
            renderItem={(item) => (
              <List.Item>
                <div className="flex gap-1 items-center" title={item.title}>
                  <span className="w-5">{item.icon}</span>{' '}
                  {item.renderText ? item.renderText(item) : item.text}
                </div>
              </List.Item>
            )}
          />
          <div className="grid grid-cols-12 gap-4 mt-2">
            <div className="col-span-6">
              <ButtonUpdate record={record} onEditSuccess={refetch} />
            </div>
            <div className="col-span-6">
              <DeleteCandidateButton
                record={record}
                onDeleteSuccess={refetch}
              />
            </div>
            <div className="col-span-12">
              <ConfirmLearn record={record} onSuccess={refetch} />
            </div>
          </div>
        </div>
        <div className="md:border-s-2 border-s-0 md:col-span-9 col-span-12 md:ps-4 ps-0">
          <MeetingHistory
            item={record}
            onFetchMeetingSuccess={onFetchMeetingSuccess}
          />
        </div>
      </div>
    </div>
  );
};

export default Detail;
